import { useEffect, useState } from "react";
import { Progress } from "@/components/ui/progress";
import { Logo } from "@/components/Logo";
import { SALON_IMAGES } from "@/lib/assets";

const QUOTES = [
  "Ein guter Schnitt folgt der Form des Gesichts — nie umgekehrt.",
  "Farbe ist Licht. Der richtige Ton lässt die Haut strahlen.",
  "Stil ist die Summe vieler kleiner, bewusster Entscheidungen.",
  "Seit 1974 im Dienst der schönsten Linien.",
];

export const LoadingScreen = ({ percent, label }) => {
  const [quote, setQuote] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setQuote((q) => (q + 1) % QUOTES.length), 7000);
    return () => clearInterval(t);
  }, []);

  return (
    <div
      className="relative grain min-h-[calc(100vh-9rem)] flex items-center justify-center px-8 overflow-hidden"
      data-testid="analysis-loading-screen"
    >
      <img
        src={SALON_IMAGES.waschbereich}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover opacity-[0.12]"
      />
      <div className="relative z-10 w-full max-w-xl text-center">
        <Logo className="h-12 sm:h-14 mx-auto mb-20 opacity-80" />
        <p className="label-xs mb-8">Beratung wird erstellt</p>
        <h1 className="font-display text-3xl sm:text-4xl font-light tracking-tight leading-tight mb-14">
          {label || "Die Auswertung läuft"}
        </h1>

        <Progress
          value={percent || 5}
          data-testid="analysis-progress"
          className="h-[3px] bg-border [&>div]:bg-foreground"
        />
        <p className="mt-5 text-xs text-muted-foreground tabular-nums" data-testid="analysis-progress-percent">
          {percent || 5} %
        </p>

        <p key={quote} className="mt-24 text-sm text-muted-foreground italic rise">
          „{QUOTES[quote]}"
        </p>
      </div>
    </div>
  );
};
